export function labelId(id: string): string {
  return idVariation(id, 'Label');
}

export function errorId(id: string): string {
  return idVariation(id, 'Error');
}

export function helpTextId(id: string): string {
  return idVariation(id, 'HelpText');
}

export function idVariation(id: string, suffix: string = ''): string {
  return `${id}${suffix}`;
}

